import React from "react";
import "../NagthaneComponent/NagthaneCss/MembersSection.css";

export default function MembersSection() {
  const members = [
    { name: "सौ. रेश्मा पवनकुमार कदम", role: "सदस्य", phone: "७५८८६८५२६९" },
    { name: "श्री. राजेश विष्णु साळुंखे", role: "सदस्य", phone: "८८३००७६८९२" },
    { name: "श्री. किरण बापू साळुंखे", role: "सदस्य", phone: " ९५९५१९९२२६" },

    { name: "सौ. दिपाली अजित साळुंखे", role: "सदस्य", phone: "९६२३९२०६७७" },
    { name: "सौ. वंदना शंकर सुतार", role: "सदस्य", phone: "९८६०८६६८२५" },
    { name: "श्री. बापू आण्णा मोहिते", role: "सदस्य", phone: "७०२००२६६३२१" },

    { name: "सौ. मनिषा शशिकांत जाधव", role: "सदस्य", phone: "९९२१८६८९४०" },
    { name: "सौ. उषा विजय कांबळे", role: "सदस्य", phone: "९६०४०६६१८७" },
    { name: "श्री. हणमंत गणपती साळुंखे", role: "सदस्य", phone: "९८५०९५१७५६" },

    { name: "सौ.उषा संजय साळुंखे", role: "सदस्य", phone: "९२७००४८८१०" },
    { name: "सौ. सुलोचना पुंडलिक साळुंखे", role: "सदस्य", phone: "७३५०२०००४९" },
    { name: "श्री. दत्तात्रय पांडुरंग साळुंखे", role: "सदस्य", phone: "९०९६८८२७८४" },

    { name: "श्री. प्रशांत प्रकाश तिवाटणे", role: "सदस्य", phone: "७९७२२४२१३१" },
    { name: "सौ. स्वप्नाली विकास नलवडे", role: "सदस्य", phone: "९३७०४९२९२९" },
    { name: "श्री. चंद्रकांत गोविंद पवार", role: "सदस्य", phone: "९८२२२०२२३८" },
  ];

  return (
    <section className="members-section">
      <div className="members-grid">
        {members.map((m, index) => (
          <div className="member-card" key={index}>
            <p className="member-name">{m.name}</p>
            <p className="member-role">{m.role}</p>
            <p className="member-phone">संपर्क : {m.phone}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
